<script>
    import { createEventDispatcher } from "svelte";
    import { _ } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    export let previousSaalNumber;
</script>

<div class="button-row">
    {#if previousSaalNumber !== 0}
        <img
            on:click={() => dispatch("previousSaal")}
            src="./images/icons/BackArrow.svg"
            alt={$_("back")}
            class="icon"
        />
        <div on:click={() => dispatch("previousSaal")} class="headline-xs">
            {$_("hall")}
            {previousSaalNumber}
        </div>
    {/if}
    <div class="flex" />
    <div on:click={() => dispatch("lastSaal")} class="headline-xs">
        {$_("previous_hall")}
    </div>
</div>

<style>
    .button-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 16px 0 16px 0;
        cursor: pointer;
    }

    .flex {
        flex: 1;
    }

    .icon {
        margin-right: 16px;
    }
</style>
